import React from 'react';
import { Dropdown, Icon, Input } from 'semantic-ui-react';
import escapeStringRegexp from 'escape-string-regexp';

class Launcher extends React.Component {
  state = {query: ''};

  render() {
    const { open, tabs, onLaunch } = this.props;
    const { query } = this.state;
    const queryRegExp = new RegExp(escapeStringRegexp(query), 'i');
    const icon = (
      <a href="#launcher" onClick={this.handleIconClick}>
        <Icon name="grid layout" color="grey" size="large" />
      </a>
    );
    return (
      <Dropdown icon={icon} open={open} onBlur={this.handleClose}>
        <Dropdown.Menu>
          <Input
            icon="search"
            iconPosition="left"
            value={query}
            onChange={this.handleQueryChange}
          />
          <Dropdown.Menu scrolling>
            {tabs.map((tab) =>
              tab.label.match(queryRegExp) && 
              <Dropdown.Item
                label={<React.Fragment>{tab.icon} {tab.label}</React.Fragment>}
                key={tab.url}
                onClick={(e) => {
                  e.preventDefault();
                  onLaunch(tab);
                }}
              />
            )}
          </Dropdown.Menu>
        </Dropdown.Menu>
      </Dropdown>
    );
  }

  handleQueryChange = (e) => {
    e.preventDefault();
    const query = e.target.value;
    this.setState((state) => ({...state, query}));
  };

  handleIconClick = (e) => {
    e.preventDefault();
    this.setState((state) => ({...state, query: ''}));
    this.props.onToggle();
  };

  handleClose = (e) => {
    e.preventDefault();
    this.props.onClose();
  };
}

export default Launcher;

Launcher.defaultProps = {
  onLaunch: () => {},
};
